import {LoginDto} from "./dto/login.dto";
import {$api} from "./$api";
import {AxiosResponse} from 'axios'
import {IAuthResponse} from "./models/IAuthResponse";
import {UpdateProfileDto} from "./dto/profile/update-profile.dto";
import {ChangePasswordDto} from "./dto/change-password.dto";

export const authApi = {
    login(dto: LoginDto): Promise<AxiosResponse<IAuthResponse>> {
        return $api.post<IAuthResponse>('/auth/login', {...dto})
    },
    registration(dto: LoginDto): Promise<AxiosResponse<IAuthResponse>> {
        return $api.post<IAuthResponse>('/auth/registration', {...dto})
    },
    checkAuth(): Promise<AxiosResponse<IAuthResponse>> {
        return $api.get<IAuthResponse>('auth/refresh')
    },
    updateProfile(dto: UpdateProfileDto) {
        return $api.patch('/users/user', {...dto})
    },
    checkRecoveryPasswordRecord(recoveryKey: string): Promise<AxiosResponse<number>> {
        return $api.post('/auth/check_recovery_key', {recoveryKey})
    },
    changePasswordWithRecoveryKey(dto: ChangePasswordDto): Promise<AxiosResponse<IAuthResponse>> {
        return $api.post('/auth/change_password', {...dto})
    },
    sendRecoveryRequest(email: string) {
        return $api.post('/auth/forgot_password', {email})
    },
    logout(token: string) {
        return $api.post('/auth/logout', {token})
    }
}